import { render, staticRenderFns } from "./gs-shop-category-entry.vue?vue&type=template&id=77b62e64"
import script from "./gs-shop-category-entry.vue?vue&type=script&lang=ts"
export * from "./gs-shop-category-entry.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports